import { api as musicboxApi } from './auto-generated/musicbox'

musicboxApi.enhanceEndpoints({
  endpoints: {},
})

export { musicboxApi }
